<app-header [withBanner]="true" *ngIf="!hideHeaderAndFooter"></app-header>

<app-hero title="{{'help_center_title' | translate}}" subtitle="{{'help_center_subtitle' | translate}}"
    imageUrl="assets/images/landing-system/hero-1.png" [imageSettings]="{width: 717, height: 674}">
</app-hero>

<div class="rs-wrapper-v4">
    <div class="default-space-between-components">
        <h3>{{'help_center_subtitle_two' | translate}}</h3>
        <div class="help-options-container">
            <app-help-options [notRedirect]="notRedirect" *ngFor="let item of helpOptionsModelCard"
                [elementsHelpOptions]="item"></app-help-options>
        </div>
    </div>

    <app-video-tutorials></app-video-tutorials>

    <app-faq-questions id="faq"></app-faq-questions>

    <div class="rs-wrapper-v4">
        <h3>{{ 'which_system_help_title' | translate }}</h3>
        <app-payment-methods [isHelpCenter]="isHelpCenter" [systems]="systems"></app-payment-methods>

        <app-blog-by-system [systemTags]="'ayuda'" title="{{'help_center_article_title' | translate}}"></app-blog-by-system>
    </div>
</div>

<!-- <app-flyer-saldo backgroundImage="../../assets/landing-social-proof/flyer1.svg">
    <div class="container-flyer centered-div">
        <h3>Comunícate con nuestro equipo de ventas <br>siempre que lo necesites</h3>
        <button (click)="openChatWithSupport()" mat-button>Hablar con ventas</button>
    </div>
</app-flyer-saldo> -->
<app-footer *ngIf="!hideHeaderAndFooter"></app-footer>
